import { z } from 'zod';
/**
 * Integrations-Contracts (Immich-Galerie, Tandoor später). Der Client spricht
 * nie direkt mit Immich — alle Bilder laufen über den Backend-Proxy, Keys
 * bleiben serverseitig (09 – Integrations-Konzept, ADR-007).
 */
export const integrationsStatusSchema = z.object({
    immich: z.boolean(),
    tandoor: z.boolean(),
});
// ── Tandoor (Speiseplan + Einkaufsliste, ADR-034) ─────────────────
export const tandoorMealDtoSchema = z.object({
    id: z.number(),
    date: z.string(), // ISO (from_date)
    mealType: z.string(),
    title: z.string(),
    imageUrl: z.string().nullable(), // Proxy-URL
    note: z.string().nullable(),
});
export const tandoorSyncResultSchema = z.object({
    listId: z.string().uuid(),
    added: z.number().int(),
    updated: z.number().int(),
    removed: z.number().int(),
    open: z.number().int(),
});
/** Ein Tandoor-Rezept (für die Wunschgericht-Auswahl). */
export const tandoorRecipeDtoSchema = z.object({
    id: z.number(),
    name: z.string(),
    imageUrl: z.string().nullable(),
});
/** Ein Wunschgericht in der Wunschliste (mit User + Datum, ADR-035). */
export const mealWishDtoSchema = z.object({
    id: z.string().uuid(),
    recipeId: z.number(),
    recipeName: z.string(),
    imageUrl: z.string().nullable(),
    wishedBy: z.string().uuid().nullable(),
    wishedByName: z.string(),
    createdAt: z.string(),
    fulfilledAt: z.string().nullable(),
    fulfilledByName: z.string().nullable(),
});
export const addWishSchema = z.object({ recipeId: z.number().int() });
export const fulfillWishSchema = z.object({ fulfilled: z.boolean() });
/** Ein für den Nest-User sichtbares Immich-Album (automatisch, ADR-032). */
export const immichAlbumDtoSchema = z.object({
    albumId: z.string(),
    title: z.string(),
    assetCount: z.number().int(),
    coverUrl: z.string().nullable(), // Proxy-URL des Titelbilds
});
/** Album in der Eltern-Verwaltung (mit Ausblend-Status + Beteiligten). */
export const immichManageAlbumDtoSchema = z.object({
    albumId: z.string(),
    title: z.string(),
    assetCount: z.number().int(),
    hidden: z.boolean(),
    sharedWith: z.array(z.string()),
});
/** Ein Foto/Video eines Albums; alle URLs zeigen auf den Backend-Bild-Proxy. */
export const immichAssetDtoSchema = z.object({
    id: z.string(),
    type: z.enum(['image', 'video']),
    thumbUrl: z.string(),
    previewUrl: z.string(),
    originalUrl: z.string(),
});
export const linkAlbumSchema = z.object({ immichAlbumId: z.string().min(1) });
//# sourceMappingURL=integrations.js.map